import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

import Whychooseimg03 from '../../assets/images/will2.png';

const Whychoosetwo = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(
                '.why-choose-two-image'
            );

            elements.forEach((el) => {
                const elementTop = el.getBoundingClientRect().top;
                const elementBottom = el.getBoundingClientRect().bottom;
                const viewportTop = 0;
                const viewportBottom = window.innerHeight;

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    el.classList.add('active');
                }
            });
        };


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });

    return (
        <div className="why-choose-two" style={{ background: "#f2f4f8" }}>

            <div className="container" id='about-will'>
                <div className="row gutter-y-30">
                    <div className="col-lg-7 align-self-center">
                        <div className="why-choose-right-two">
                            <div className="heading-box heading-white">
                                <p style={{ marginBottom: "30px" }}>Our team has a lot of experience helping NRIs with assets or family in India. We ensure that your wealth is passed on exactly how you want, without traveling or facing legal hurdles</p>

                                <h2 className="heading-title wow fadeInUp animated animated text-black" style={{ marginTop: '0px', paddingTop: "0px", }}>
                                    Why Choose The NRI Advisors?
                                </h2>
                            </div>
                            <ul className='features-one-list1' style={{ display: "flex", flexDirection: "column" }}>
                                <li>Personalized service with the human touch.</li>
                                <li>Based in Canada. Trusted globally.</li>
                                <li>End-to-end legal support.</li>
                                <li>100% remote process</li>
                                <li>Peace of mind for you and your Family</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="why-choose-two-image">
                            <img
                                src={Whychooseimg03} alt="why-choose-image"
                            />
                            <div className="image-shape">
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 mt-5">
                        <div className="row gutter-y-30">
                            {whychoosedata.map((data, index) =>
                                <div key={index}
                                    className="col-lg-4" >
                                    <div className="why-choose-two-box">
                                        <i className="flaticon-transparency" />
                                        <div className="why-choose-two-box-info">
                                            <h4>{data.heading}</h4>
                                            <p>
                                                {data.about}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>
            </div>
        </div >


    )
}
export default Whychoosetwo;